import React from "react";
import { Navigate } from "react-router-dom";

import useAuth from "../../hooks/useAuth";

const GuestGuard = ({ children }) => {
  const { isLoggedIn, user } = useAuth();
  if (isLoggedIn) {
    if (user?.startScreen) {
      //startScreen
      return <Navigate to="/auth/start-info" />;
    }
    return <Navigate to="/" />;
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default GuestGuard;
